import { DayOfWeek } from './c-types/day-of-week.enum';

export const SummitConfig = {
  defaultEndOfWeek: DayOfWeek.Friday,
  defaultEndOfScheduleWeek: DayOfWeek.Sunday,
  defaultEndOfIvmrWeek: DayOfWeek.Saturday
};
